module.exports = __webpack_public_path__ + "static/carousel-background-mobile-5ee3d771933f441129a4884188f2a80d.jpg";